import React from 'react';
import { Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const InvoiceIcon = ({ processingDetail, urlPdf, status }) => {
  const icons = {
    authorized: {
      icon: 'print'
    },
    canceled: { icon: ['far', 'times-circle'] },
    received: { icon: 'hourglass-half' },
    enqueued: { icon: 'spinner' },
    rejected: { icon: 'exclamation-triangle' },
    inContingent: { icon: 'exclamation-triangle' }
  };

  const props =
    processingDetail?.status === 'processing' ? icons.enqueued : icons[status];

  let title = '';

  if (processingDetail) {
    const { message, code } = processingDetail;
    title = code ? `${code} - ${message}` : message;
  }

  const handleDownload = () => {
    if (urlPdf) {
      window.open(urlPdf, '_blank').focus();
    }
  };

  if (props) {
    return (
      <Tooltip title={title} placement="right">
        {status === 'authorized' ? (
          <FontAwesomeIcon
            className="icon gx-pointer gx-text-dark gx-fs-sm gx-ml-1"
            {...props}
            onClick={handleDownload}
          />
        ) : (
          <FontAwesomeIcon
            className="icon gx-pointer gx-text-dark gx-fs-sm gx-ml-1"
            {...props}
          />
        )}
      </Tooltip>
    );
  }

  return null;
};

export default InvoiceIcon;
